<div class="discount-form p-6 bg-white rounded shadow-md lg:ml-6" *ngIf="allowInputDiscount">
  <div class="text-[24px] font-semibold">{{'discount-form.title' | translate}}</div>
  <div class="text-body text-gray-3 mt-2">
    {{'discount-form.desc' | translate}}
  </div>

  <div class="mt-2 mb-2" *ngFor="let discount of discounts">{{discount.accessCode}}: {{discount.description ||
    discount.name}} <span *ngIf="discount.expired">(expired)</span></div>


  <form class="mt-6">
    <div class="text-caption font-semibold">{{'booking.discount-code' | translate}}</div>
    <div class="flex mt-2 items-center discount-form-wrap">
      <div class="flex-1">
        <input pInputText type="text" id="discountCode" name="discountCode" pInputText
          [(ngModel)]="discountForm.discountCode" class="w-full" autocomplete="off"
          [placeholder]="'booking.your-discount-code' | translate">
      </div>
      <button class="btn-discount" (click)="applyDiscountCode()" [disabled]="discountForm.isProcessing">
        <span class="material-symbols-outlined">
          east
        </span>
      </button>
    </div>
    <div class=" text-red-500 mt-2" *ngIf="discountForm.errors.discountCode">{{discountForm.errors.discountCode |
      translate}}</div>
  </form>

  <div class="mt-4 flex items-center">
    <div class="flex-1 mr-2 text-body">
      <strong *ngIf="discounts && discounts.length">{{'booking.applied' | translate}}:</strong>
      <span class="apply-discount-item" *ngFor="let discount of discounts">
        {{discount.accessCode}}
        <span (click)="removeDiscount(discount)" class="cursor-pointer"><span
            class="material-symbols-outlined text-[20px]">
            delete
          </span></span>
      </span>
    </div>
  </div>
</div>